export const baseGraphOptions = {
  maintainAspectRatio: false,
} as const
